var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHe(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xE3\x83\x98"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stroke 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill",
    d: "M3.90399 38.016L8.70399 42.88C9.66399 41.536 11.072 39.552 12.416 37.952C15.296 34.368 20.672 27.392 23.744 23.616C25.92 20.992 27.136 20.8 29.568 23.168C32.32 25.792 38.208 32.128 41.92 36.352C46.08 41.024 51.712 47.552 56.256 53.056L60.608 48.384C55.68 43.136 49.344 36.16 44.992 31.616C41.28 27.648 35.776 21.888 31.872 18.176C27.52 14.08 24.512 14.784 21.12 18.816C17.088 23.552 11.52 30.656 8.44799 33.728C6.78399 35.456 5.56799 36.608 3.90399 38.016Z",
    fill: "black",
    fillOpacity: 0.75
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trace",
    d: "M6 41C17 28.5 23.8372 18.1753 27 18.5C30.1628 18.8247 44.5 35 59 51.5",
    stroke: "#FF0000",
    strokeOpacity: 0.5,
    strokeWidth: 8
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHe);
export default __webpack_public_path__ + "static/media/he.eb72070095935f3a90816724b85a7c38.svg";
export { ForwardRef as ReactComponent };